import React, { Component } from "react";
import { TimelineLite } from "gsap/all";
import {Container} from "./Container";
import PropTypes from "prop-types";

export class Modal extends Component {

    static propTypes = {
        visible: PropTypes.bool.isRequired,
        style: PropTypes.any,
        onClose: PropTypes.func
    };

    static defaultProps = {
        visible: false,
        onClose: () => undefined
    };

    constructor(props){
        // call base constructor
        super(props);

        // initialize instance variable
        this.modalWrap = null;
        this.modalDialog = null;
        this.modalTween = new TimelineLite({ paused: true });
    }

    componentDidMount() {
        this.modalTween
            .to(this.modalWrap.div, 0.01, { autoAlpha: 1 })
            .to(this.modalDialog.div, 0.25, { y: 50, autoAlpha: 1 }, 0)
            .reversed(true)
            .paused(false);
    }

    componentDidUpdate() {
        this.modalTween.reversed(!this.props.visible);
    }

    render() {

        // resolve inputs
        const { visible, style, onClose, children } = this.props;

        return (
            <Container flex
                       justify="center"
                       alignItems="center"
                       style={styles.container}
                       ref={div => this.modalWrap = div}
                       onClick={onClose}>

                <Container justify="space-between"
                           alignContent="space-between"
                           style={{...styles.modal, ...style}}
                           ref={div => this.modalDialog = div}>

                    {children}

                </Container>

            </Container>
        );
    }

}

const styles = {
    container: {
        position: "absolute",
        height: "100%",
        width: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 11,
        opacity: 0,
        visibility: "hidden",
        userSelect: "none"
    },
    modal: {
        width: 575,
        height: 290,
        border: "solid 1px #ffd200",
        backgroundColor: "#000000",
        padding: 38,
        display: "flex"
    }
};


// WEBPACK FOOTER //
// ./src/components/Modal.js